import { createSlice } from '@reduxjs/toolkit';

import { getCoursesLessons } from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  totalPages: null as any,
  perPage: 100,
};

const coursesLessonsSlice = createSlice({
  name: 'coursesLessons',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getCoursesLessons.fulfilled, (_: any, action: any) => {
      return action.payload;
    });
  },
});

export default coursesLessonsSlice.reducer;
